import { Injectable } from '@angular/core';
import { ApiService } from "../api/api.service";
import { BehaviorSubject } from 'rxjs';
import {Terms} from '../models/models.lib';

@Injectable({
  providedIn: 'root'
})
export class TermsConditionsService {

  private _doc: BehaviorSubject<Terms> = new BehaviorSubject<Terms>(new Terms());
  get doc$() {
    return this._doc.asObservable();
  }
  get doc() {
    return this._doc.getValue();
  }
  set doc(val: Terms) {
    this._doc.next(val);
  }

  constructor(
    private apiService: ApiService
  ) { }

  get(docType: string): Promise<any> {
    return this.apiService.getHttpCallAsPromise(`termsconditions?doc_type=${docType}`, 'get')
      .then((resp: any) => {
        this.doc = Terms.create(resp);
        return this.doc;
      });
  }

  updateUserTerms(info: any): Promise<any> {
    return this.apiService.putHttpCallAsPromise(`updateuserterms`, info, 'updateUserTerms');
  }

}
